import React, { useEffect, useState } from "react";
import { getAPIService, postAPIService } from "../../services/CallAPI";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import KickBox from "../KickBox";
import CodeErrorBox from "../CodeErrorBox";
import VideoContent from "../VideoContent";
import VideoPlayback from "../VideoPlayback";
import ChatContent from "../ChatContent";
import GateAgent from "./GateAgent";
import LoadingBox from "../LoadingBox";
import EoProfile from "./EoProfile";
import BannerSlide from "../BannerSlide";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import WarpImgLink from "../../components/WarpImgLink";
import { S3_PUBLIC_PATH } from "../../config/constants";
import EventName from "./EventName";
import useStyles, { StyledTabs, StyledTab } from "./styled";

const MainContent = (props) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  let QRCode = urlSearchParams.get("QRCode");
  const [qr, setQR] = useState("");
  const [eventDetail, setEventDetail] = useState({
    isLoading: false,
    eventFound: false,
  });
  const [eo, setEo] = useState({});
  const [streamData, setStreamData] = useState({
    data_live: {},
    ticket_type: {},
    user: {},
  });
  const [videoPlay, setVideoPlay] = useState("");
  const [isEntry, setIsEntry] = useState(false);
  const [isLoadingEntry, setIsLoadingEntry] = useState(false);
  const [isKickBox, setIsKickBox] = useState(false);
  const [isCodeErrorbox, setIsCodeErrorBox] = useState(false);
  const { eventId } = useParams();
  const [socketID, setSocketId] = useState(new Date().getTime());
  const [socketTime, setSocketTime] = useState(new Date().getTime());
  const [socket, setSocket] = useState({});
  const [tabValue, setTabValue] = React.useState(0);
  const [intervalConnect, setIntervalConnect] = useState("");
  useEffect(() => {
    initPage();
  }, []);
  const initPage = async () => {
    await getEvent();
  };
  const getEvent = async () => {
    setEventDetail({ ...eventDetail, isLoading: true, eventFound: false });
    const url = "https://api.ticketmelon.com/v1/s1/events/" + eventId;
    const res = await getAPIService(url);
    if (res.status) {
      const eventData = res.message.Items[0] || {};
      if (eventData.event_id) {
        await setEventDetail({
          ...eventData,
          isLoading: false,
          eventFound: true,
        });
        await getEO(eventData.eo_profile_id);
        if (QRCode) {
          setQR(QRCode.toUpperCase());
          await scanQRCode(QRCode.toUpperCase());
        }
      } else {
        await setEventDetail({
          ...eventData,
          isLoading: false,
          eventFound: false,
        });
      }
    } else {
      setEventDetail({ ...eventDetail, isLoading: false, eventFound: false });
    }
  };
  const getEO = async (eoId) => {
    const url = "https://api.ticketmelon.com/v1/s1/eo/" + eoId;
    const res = await getAPIService(url);
    if (res.status) {
      const eo = res.message.Items[0] || {};
      await setEo(eo);
    } else {
      await setEo({});
    }
  };
  const scanQRCode = async (qrcode) => {
    setIsLoadingEntry(true);
    setQR(qrcode);
    await onGeteAgentScan(qrcode);
    setIsLoadingEntry(false);
  };
  const onGeteAgentScan = async (qrcode) => {
    const url = `https://api.ticketmelon.com/v2/s1/users/events/${eventId}/login-live`;
    const header = {
      "content-type": "application/json",
    };
    const body = {
      code: qrcode.replace(/\s/g, ""),
    };
    const res = await postAPIService(url, header, JSON.stringify(body));
    if (res.status) {
      const { data_live, ticket_type, user } = res.message;
      await setStreamData({ data_live, ticket_type, user });
      setIsEntry(true);
      let isLiveSocket = eventDetail.is_live_socket
        ? eventDetail.is_live_socket
        : "true";

      if (data_live.video_list.length > 0) {
        setVideoPlay(data_live.video_list[0].video_id);
        if (isLiveSocket == "true") {
          connectSocket(qrcode);
        }
      } else {
        setVideoPlay(data_live.meetingNumber);
        if (isLiveSocket == "true") {
          connectSocket(qrcode);
        }
      }
    } else {
      setIsCodeErrorBox(true);
    }
  };
  const onCloseKickBox = () => {
    setIsKickBox(false);
  };
  const onEnterCode = async (code) => {
    setIsLoadingEntry(true);
    await onGeteAgentScan(code);
    setIsLoadingEntry(false);
  };
  const onCloseCodeErrorBox = () => {
    setIsCodeErrorBox(false);
  };
  const connectSocket = (qrcode) => {
    const socketIdTMP = new Date().getTime();
    let keepConnect = "";
    let socketTMP = new WebSocket(
      `wss://nsvn26qw71.execute-api.ap-southeast-1.amazonaws.com/production?code=${qrcode
        .toUpperCase()
        .split("-")
        .join("")
        .replace(/\s/g, "")}&event_id=${eventId}&client_id=${socketIdTMP}`
    );
    socketTMP.onopen = (e) => {
      console.log("onopen");
      setSocketId(socketIdTMP);
      setSocketTime(new Date().getTime());
      keepConnect = setInterval(() => {
        socketTMP.send("connect..");
      }, 1000 * 5);
    };
    socketTMP.onmessage = (event) => {
      console.log("onclose");
      const socketData = JSON.parse(event.data);
      let isConnection = false;
      Object.keys(socketData).map((row) => {
        if (socketData[row].client_id === socketIdTMP + "") {
          isConnection = true;
        }
      });
      if (!isConnection) {
        socketTMP.close(3000, "limit access");
        setIsKickBox(true);
        setIsEntry(false);
        setStreamData({});
      }
    };
    socketTMP.onclose = (event) => {
      console.log("onclose");
      onCloseInterval(keepConnect);
      if (event.wasClean) {
        if (event.code !== 3000) {
          reconnectSocket();
        }
      } else {
        console.error("onclose2", event);
        socketTMP.close(3000, "limit access");
        setIsKickBox(true);
        setIsEntry(false);
        setStreamData({});
      }
    };
    socketTMP.onerror = function (error) {
      console.error("onerror", error);
      onCloseInterval(keepConnect);
      reconnectSocket();
    };
    setSocket(socketTMP);
  };
  const onCloseSocket = () => {
    socket.close(3001, "close");
  };
  const onCloseInterval = (keepConnect) => {
    clearInterval(keepConnect);
  };
  const reconnectSocket = () => {
    connectSocket(qr);
  };
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setTabValue(index);
  };
  const onClickVideoList = (videoId) => {
    setVideoPlay(videoId);
  };
  const logo =
    eventDetail.image_5?.length > 0
      ? eventDetail.image_5[0].url
      : S3_PUBLIC_PATH + "MelonLive-Logo-White.png";
  const banner = eventDetail.image_4 || [];
  const eventStyle = eventDetail.style || { bg_color: "#ffffff" };
  const classes = useStyles({ eventStyles: eventStyle });
  return (
    <div className={classes.page}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Live Streaming of ${eventDetail.name}`}</title>
        <meta
          http-equiv="Cache-Control"
          content="no-cache, no-store, must-revalidate, max-age=0"
        />
        <meta http-equiv="Pragma" content="no-cache" />
      </Helmet>
      <KickBox isOpen={isKickBox} onClose={onCloseKickBox} />
      <CodeErrorBox isOpen={isCodeErrorbox} onClose={onCloseCodeErrorBox} />
      <LoadingBox isOpen={isLoadingEntry} />
      {!eventDetail.isLoading && eventDetail.eventFound ? (
        <div className={classes.root}>
          <Hidden smDown>
            <Container>
              {
                  !isEntry && <div className={classes.navbar}>
                    <div className={classes.logoSite}>
                      <img src={logo} style={{maxWidth:'100%', height:'auto'}} />
                    </div>
                </div>
                }
              <Grid container spacing={2} justify="center">
                {
                  isEntry ? <>
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        {banner.length > 0 && (
                          <Grid item md={12}>
                            <BannerSlide banner={banner} />
                          </Grid>
                        )}
                        <Grid item md={12}>
                          <VideoContent liveId={videoPlay}  height={'660px'} />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item md={3}>
                      <Grid container spacing={2}>
                        <Grid item sm={12} xs={12} md={12}>
                          <EoProfile eventStyles={eventStyle} eo={eo || {}} />
                        </Grid>
                        <Grid item sm={12} xs={12} md={12}>
                          {streamData.data_live.video_list &&
                            streamData.data_live.video_list.length === 0 ? (
                            <ChatContent liveId={videoPlay} />
                          ) : (
                            <VideoPlayback
                              eventStyles={eventStyle}
                              streamData={streamData || []}
                              onClick={onClickVideoList}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </> : <>
                    <Grid container spacing={2} justifyContent='center' className={classes.containerNotEntry}>
                      <Grid item md={9}>
                        <GateAgent
                          eventDetail={eventDetail}
                          code={QRCode}
                          onEnterCode={onEnterCode}
                        />
                        <br />
                        <EventName
                          eventDetail={eventDetail}
                          eo={eo}
                          isEntry={isEntry}
                        />
                      </Grid>
                    </Grid>
                  </>
                }
              </Grid>
            </Container>
          </Hidden>

          {/* ////mobile */}
          <Hidden mdUp style={{ height: "100%" }}>
            <div className={classes.navbar}>
              <div className={classes.logoSite}>
                 <img src={logo} style={{maxWidth:'100%', height:'auto'}} />
              </div>
            </div>
            {isEntry ? (
              <div>
                <EventName
                  eventDetail={eventDetail}
                  eo={eo}
                  isEntry={isEntry}
                />

                <VideoContent liveId={videoPlay} />
                <div style={{ marginTop: 16}}>
                {streamData.data_live.video_list &&
                      streamData.data_live.video_list.length === 0 ? (
                      <ChatContent liveId={videoPlay} />
                    ) : (
                      <VideoPlayback
                        eventStyles={eventStyle}
                        streamData={streamData || []}
                        onClick={onClickVideoList}
                      />
                    )}
                  {/* <StyledTabs
                    value={tabValue}
                    onChange={handleChange}
                    bgColor={eventStyle.button_color}
                    variant="scrollable"
                  >
                    <StyledTab
                      fontColor={eventStyle.font_color}
                      bgColor={eventStyle.button_color}
                      label={
                        streamData.data_live.video_list &&
                          streamData.data_live.video_list.length === 0
                          ? "Chat"
                          : "Video Playback"
                      }
                    />
                    <StyledTab label="Description" />
                  </StyledTabs>
                  <TabPanel value={tabValue} index={0}>
                    {streamData.data_live.video_list &&
                      streamData.data_live.video_list.length === 0 ? (
                      <ChatContent liveId={videoPlay} />
                    ) : (
                      <VideoPlayback
                        eventStyles={eventStyle}
                        streamData={streamData || []}
                        onClick={onClickVideoList}
                      />
                    )}
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    <div
                      className={classes.description}
                      dangerouslySetInnerHTML={{
                        __html: eventDetail.description,
                      }}
                    />
                  </TabPanel> */}
                </div>
              </div>
            ) : (
              <Grid container disableGutters direction="column">
                <Grid item xs={12} md={12}>
                  <GateAgent
                    eventDetail={eventDetail}
                    code={QRCode}
                    onEnterCode={onEnterCode}
                  />
                </Grid>
                <Grid item xs={12} md={12} style={{ padding: "0 16px" }}>
                  <EventName
                    eventDetail={eventDetail}
                    eo={eo}
                    isEntry={isEntry}
                  />
                </Grid>

              </Grid>
            )}
          </Hidden>
        </div>
      ) : (
        !eventDetail.isLoading &&
        !eventDetail.eventFound && (
          <Container disableGutters>event not found</Container>
        )
      )}
      {/* <Button onClick={onCloseSocket}>Close</Button> */}
    </div>
  );
};

export default MainContent;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}
